import { getPriceInputError, normalizePriceInput } from "@/utils/priceInput";

const priceInputs = new Set();

export function focusInvalidPriceInput(root) {
  const candidates = [...priceInputs].filter(
    (el) => !root || root.contains(el),
  );
  for (const el of candidates) {
    const state = el.__priceInput;
    const input = el.matches("input,textarea")
      ? el
      : el.querySelector("input,textarea");
    if (
      !state.enabled ||
      !input ||
      input.disabled ||
      input.readOnly ||
      !input.getClientRects().length
    )
      continue;
    if (!getPriceInputError(input.value, { optional: true })) continue;
    input.scrollIntoView({ behavior: "smooth", block: "center" });
    input.focus({ preventScroll: true });
    return true;
  }
  return false;
}

// 仅在显式标注的价格输入上生效。捕获 blur，先规范化再让表单执行校验。
export default {
  bind(el, binding, vnode) {
    const state = {
      vnode,
      enabled: !binding.expression || Boolean(binding.value),
    };
    state.blur = (event) => {
      if (!state.enabled) return;
      const node = state.vnode;
      const component = node.componentInstance;
      const input = event.target;
      if (!input || !/^(INPUT|TEXTAREA)$/.test(input.tagName)) return;
      if (input.disabled || input.readOnly) return;
      const value = normalizePriceInput(input.value);
      input.value = value;
      if (node.data && node.data.model) {
        node.data.model.callback(value);
      } else if (component) {
        component.$emit("input", value);
      } else {
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
      // 无表单容器的行内编辑也展示同一提示，不能只在提交时才发现错误。
      if (input.setCustomValidity) {
        // 最多4位小数等固定提示按当前语言显示，校验与原始输入不变。
        const error = getPriceInputError(value, { optional: true });
        input.setCustomValidity(
          node.context?.$localizePriceError
            ? node.context.$localizePriceError(error)
            : error,
        );
        if (input.validationMessage && input.reportValidity)
          input.reportValidity();
      }
    };
    state.input = (event) => {
      if (!state.enabled) return;
      if (event.target.setCustomValidity) event.target.setCustomValidity("");
    };
    el.__priceInput = state;
    priceInputs.add(el);
    el.addEventListener("blur", state.blur, true);
    el.addEventListener("input", state.input, true);
  },
  update(el, binding, vnode) {
    el.__priceInput.vnode = vnode;
    el.__priceInput.enabled = !binding.expression || Boolean(binding.value);
  },
  unbind(el) {
    const state = el.__priceInput;
    el.removeEventListener("blur", state.blur, true);
    el.removeEventListener("input", state.input, true);
    delete el.__priceInput;
    priceInputs.delete(el);
  },
};
